import { Component, Input } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';

import { MatIconModule } from '@angular/material/icon';
import { ResumeService } from '../services/resume.service';
import { UserDetailDTO } from '../model/user-detail-dto';
import { CategoryConst } from '../model/category-const';

@Component({
  selector: 'app-cv-resume',
  standalone: true,
  imports: [MatIconModule, CommonModule],
  templateUrl: './cv-resume.component.html',
  styleUrl: './cv-resume.component.scss'
})
export class CvResumeComponent {

  @Input('id') id!: string;
  userDetail: UserDetailDTO;

  constructor(private route: ActivatedRoute, private resumeService: ResumeService) { }

  ngOnInit(): void {

    this.resumeService.getUserData(this.id).subscribe({
      next: (response) => {
        this.userDetail = response.data;
      },
      error: (error) => {
        console.log(error);
      }
    }
    )

  }

  findCategorySpecs(categoryId: number): any {
    let spec;
    switch (categoryId) {
      case 1:
        spec = CategoryConst.cleaningCategory;
        break;
      case 2:
        spec = CategoryConst.PetCategory;
        break;
      case 3:
        spec = CategoryConst.TechCategory;
        break;
      case 4:
        spec = CategoryConst.helperCategory;
        break;
      case 5:
        spec = CategoryConst.BuildingCategory;
        break;
      case 6:
        spec = CategoryConst.BeautyCategory;
        break;
      default:
        spec = "";
        break;
    }
    return spec;

  }



}
